export default __webpack_public_path__ + "static/media/createEvent3.f06b35ba.png";